module.exports = __webpack_public_path__ + "assets/info_white@2x.png";